module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"seeBackstage":"Vedi Backstage"},"en":{"seeBackstage":"See Backstage"}}')
  delete Component.options._Ctor
}
